import { Reveal, Dots } from "./motion/Reveal";

export default function SectionHeader({ chapter, eyebrow, title, description, dark = false, align = "left", testid }) {
  return (
    <Reveal className={`mb-12 max-w-3xl lg:mb-16 ${align === "center" ? "mx-auto text-center" : ""}`}>
      {(chapter || eyebrow) && (
        <p className={`mb-4 flex items-center gap-3 font-mono-accent text-xs uppercase tracking-[0.25em] ${dark ? "text-dot-amber" : "text-slate-500"} ${align === "center" ? "justify-center" : ""}`}>
          {chapter && <span className={dark ? "text-white/50" : "text-navy"}>{chapter}</span>}
          <Dots size="h-1.5 w-1.5" />
          {eyebrow}
        </p>
      )}
      <h2
        className={`font-display text-3xl font-semibold leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-navy-dark"}`}
        data-testid={testid}
      >
        {title}
      </h2>
      {description && (
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-white/70" : "text-slate-600"}`}>{description}</p>
      )}
    </Reveal>
  );
}
